import { eventEmitter } from '@magicdoor/solid-use-case-core';
import { createEffect } from 'solid-js';
export const Navigator = (props) => {
    const handleNavigation = (url) => {
        if (url) {
            props.onNavigate?.(url);
        }
    };
    createEffect(() => {
        eventEmitter.registerForNavigation(handleNavigation);
        return () => {
            eventEmitter.unregisterFromNavigation(handleNavigation);
        };
    });
    return null;
};
